export type PayUri = {
  chain: string;
  address: string;
  asset: string;
  amount: string;
  amountMode: "fixed" | "variable";
};

export function defaultAsset(chain: string): string {
  const c = chain.toLowerCase();
  if (c === "bsc") return "USDT";
  if (c === "nmc") return "NMC";
  return "TOKEN";
}

export function buildPayUri(input: {
  chain: string;
  address: string;
  asset?: string;
  amount?: string;
  amountMode?: "fixed" | "variable";
  base?: string;
}): string {
  const a = input.address.trim();
  if (!a) throw new Error("ADDRESS");
  const mode = input.amountMode === "fixed" ? "fixed" : "variable";
  const amt = (input.amount || "").trim();
  if (mode === "fixed" && !amt) throw new Error("AMOUNT");
  const params = new URLSearchParams();
  params.set("c", (input.chain || "bsc").toLowerCase());
  params.set("a", a);
  params.set("t", input.asset || defaultAsset(input.chain));
  params.set("m", mode === "fixed" ? "f" : "v");
  if (amt) params.set("n", amt);
  const root = (input.base || `${window.location.origin}/`).replace(/\/?$/, "/");
  return `${root}#pay?${params.toString()}`;
}

export function parsePayUri(raw: string): PayUri | null {
  const s = raw.trim();
  if (!s) return null;
  if (/^0x[a-fA-F0-9]{40}$/.test(s)) {
    return { chain: "", address: s, asset: "USDT", amount: "", amountMode: "variable" };
  }
  try {
    let qs = "";
    if (s.startsWith("nanom:pay?")) qs = s.slice("nanom:pay?".length);
    else {
      const hashIdx = s.indexOf("#pay?");
      if (hashIdx >= 0) qs = s.slice(hashIdx + 5);
      else {
        const u = new URL(s, window.location.origin);
        if (u.hash.startsWith("#pay?")) qs = u.hash.slice(5);
        else return null;
      }
    }
    const p = new URLSearchParams(qs);
    const mode = p.get("m") === "f" ? "fixed" : "variable";
    return {
      chain: (p.get("c") || "").toLowerCase(),
      address: p.get("a") || "",
      asset: p.get("t") || "USDT",
      amount: p.get("n") || "",
      amountMode: mode,
    };
  } catch {
    return null;
  }
}
